// extracted by mini-css-extract-plugin
export default {"button":"StyleSecondarySmallFalse_button__b9dmg","stylesecondarySmallfalse":"StyleSecondarySmallFalse_stylesecondarySmallfalse__iHfO1"};